import { Injectable } from '@angular/core';
import { PerformerEntity } from './entities/performer.entity';
import { BizComponentEntity } from '../../domain/entities/biz-component.entity';
import { ReportingLineDataEntity } from './views/reporting-line/reporting-line-data.entity';
import { PerformerInfo } from './entities/performer-info.entity';
import { PerformerDescription } from './entities/performer-description';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';

@Injectable()
export class PerformerUIState {
    performersList: PerformerDescription[] = [];
    curPerformer: any;
    typeCollection = [
        { text: '用户', value: 'wf.UserParticipantExpression' },
        { text: '变量参与者', value: 'wf.VariableParticipantExpression' },
        { text: '岗位', value: 'wf.PositionParticipantExpression' },
        { text: '构件参与者', value: 'wf.ComponentParticipantExpression' },
        { text: '汇报关系', value: 'wf.ReportingLineParticipantExpression'},
        { text: '矩阵', value: 'wf.MatrixParticipantExpression'},
        { text: '历史活动办理人', value: 'wf.ActivityExecutorParticipantExpression' },
        { text: '单位/部门', value: 'wf.OrganizationParticipantExpression'}
    ];

    performerInfo: PerformerInfo = {
        performers: [],
        variablePerformers: [],
        components: [],
        reportingLines: [],
        matrixParticipants: [],
        activityExecutors: [],
        organizationParticipants: [],
        options: null,
        isAllScope: false
    };

    constructor(private uiState: ProcessDesignerUIState) {
        if (this.uiState.scene === 'inSuite') {
            this.typeCollection = [
                { text: '用户', value: 'wf.UserParticipantExpression' },
                { text: '变量参与者', value: 'wf.VariableParticipantExpression' },
                { text: '角色', value: 'wf.PositionParticipantExpression' },
                { text: '构件参与者', value: 'wf.ComponentParticipantExpression' },
                { text: '汇报关系', value: 'wf.ReportingLineParticipantExpression' },
                { text: '矩阵', value: 'wf.MatrixParticipantExpression' },
                { text: '历史活动办理人', value: 'wf.ActivityExecutorParticipantExpression' },
                { text: '单位/部门', value: 'wf.OrganizationParticipantExpression' }
            ];
        } else {
            this.typeCollection = [
                { text: '用户', value: 'wf.UserParticipantExpression' },
                { text: '变量参与者', value: 'wf.VariableParticipantExpression' },
                { text: '岗位', value: 'wf.PositionParticipantExpression' },
                { text: '构件参与者', value: 'wf.ComponentParticipantExpression' },
                { text: '汇报关系', value: 'wf.ReportingLineParticipantExpression' },
                { text: '矩阵', value: 'wf.MatrixParticipantExpression' },
                { text: '历史活动办理人', value: 'wf.ActivityExecutorParticipantExpression' },
                { text: '单位/部门', value: 'wf.OrganizationParticipantExpression' }
            ];
        }
    }

    clearPerformer() {
        this.performerInfo.performers = new Array();
        this.performerInfo.components = new Array();
        this.performerInfo.reportingLines = new Array();
        this.performerInfo.matrixParticipants = new Array();
        this.performerInfo.activityExecutors = new Array();
        this.performerInfo.organizationParticipants = new Array();

        this.performersList = new Array();
    }
}
